import { Row, Col, Label, Input } from "reactstrap";

const EcnHeaderTab = ({ data, update }) => {

    return (
        <>
            <Row className="mb-3">
                <Col md={6}>
                    <Label>ECN Title</Label>
                    <Input
                        value={data.title || ""}
                        onChange={(e) =>
                            update("title", e.target.value)
                        }
                    />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={4}>
                    <Label>Date Needed</Label>
                    <Input
                        type="date"
                        value={data.dateNeeded || ""}
                        onChange={(e) =>
                            update("dateNeeded", e.target.value)
                        }
                    />
                </Col>

                <Col md={4}>
                    <div className="form-check mt-4">
                        <Input
                            type="checkbox"
                            checked={data.customerApprovalRequired || false}
                            onChange={(e) =>
                                update("customerApprovalRequired", e.target.checked)
                            }
                        />
                        <Label className="form-check-label">
                            Customer Approval Required
                        </Label>
                    </div>
                </Col>

                <Col md={4}>
                    <div className="form-check mt-4">
                        <Input
                            type="checkbox"
                            checked={data.customerNotificationRequired || false}
                            onChange={(e) =>
                                update("customerNotificationRequired", e.target.checked)
                            }
                        />
                        <Label className="form-check-label">
                            Customer Notification Required
                        </Label>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default EcnHeaderTab;